<ng-container *ngIf="!isMaskedValue; else maskedInput">
  <div
    (click)="toggleOverlay()"
    class="selected-info"
    [ngClass]="{ disabled: disabled }"
    [matTooltip]="selectedNodes | selectedNodesText"
    matTooltipPosition="above"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
  >
    <span class="dropdown-content">
      {{ selectedNodes | selectedNodesText | ellipsis: 35 : '' }}
    </span>
    <div class="dropdown-icons">
      <mat-icon
        *ngIf="!disabled && ((isSingleSelectMode && selectedNodes != null) || selectedNodes?.length > 0)"
        miqStopClick
        aria-label="Close icon"
        class="clear"
        (click)="clearSelectedNode()"
        >close</mat-icon
      >
      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
    </div>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayPanelClass="miq-naics-input"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayPush]="true"
    (backdropClick)="closeOverlay()"
    (overlayOutsideClick)="closeOverlay()"
    [cdkConnectedOverlayPositions]="overlayPositions"
  >
    <div class="naics-overlay">
      <div class="naics-container">
        <div class="searchbox">
          <input
            class="searchBox"
            type="text"
            autocomplete="no-autofill"
            [formControl]="searchBar"
            [placeholder]="'shared.search' | xTranslate"
          />
          <mat-icon>search</mat-icon>
        </div>
        <p-tree
          [value]="naicsCodes"
          [selectionMode]="selectionMode"
          (onNodeSelect)="handleNodeSelection($event.node)"
          [(selection)]="selectedNodes"
          [style]="{ width: '100%' }"
        >
        </p-tree>
      </div>
    </div>
  </ng-template>
</ng-container>

<!-- DISPLAYED IF MASKED DATA -->
<ng-template #maskedInput>
  <div class="selected-info disabled">
    <span class="dropdown-content">{{ currentValue }}</span>
  </div>
</ng-template>
